<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height="24"
    width="24"
  >
    <path
      class="st1"
      d="M6,2A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6M6,4H13V9H18V20H6V4M8,12V14H16V12H8M8,16V18H13V16H8Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'OmIcon',
};
</script>

<style scoped lang="scss">
.st1 {
  fill: main.$npGray;
}
</style>
